'use client';

import React from 'react';

import dynamic from 'next/dynamic';

import { retryChunkImport } from '@/lib/retryChunkImport';
import { StoreTabSkeleton } from '@/app/store/StoreTabSkeleton';

// The store layout drags the whole store surface (shared-ui layout, template
// registry, offer plumbing) with it. Loading it on demand keeps pages whose
// blocks contain no offers from shipping any of that; pages that do show the
// same skeleton the wrapper itself uses while offers load.
const StoreLayoutWrapper = dynamic(
  () =>
    retryChunkImport(() =>
      import('@/app/store/StoreLayoutWrapper').then((mod) => mod.StoreLayoutWrapper)
    ),
  { ssr: false, loading: () => <StoreTabSkeleton /> }
);

interface IOfferItemProps {
  offerIds?: string[];
  offerType?: string;
}

export const OfferItem: React.FC<IOfferItemProps> = ({ offerIds, offerType }) => {
  return <StoreLayoutWrapper offerIds={offerIds} onlyBlockOffers={true} />;
};
